import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../../../components/modal/Modal";
import MainButton from "../../../components/button/MainButton";
import SelectField from "../../../components/input/SelectField";

const DOMAIN = "@slashmobility.com";

export default function InviteUserModal({ isOpen, onClose, onInvite }) {
  const { t } = useTranslation();

  const [inviteEmail, setInviteEmail] = useState("");
  const [inviteError, setInviteError] = useState("");

  const [inviteRole, setInviteRole] = useState("USER");

  useEffect(() => {
    if (!isOpen) return;
    setInviteEmail("");
    setInviteError("");
    setInviteRole("USER");
  }, [isOpen]);

  const roleOptions = [
    { value: "USER", label: "User" },
    { value: "ADMIN", label: "Admin" },
  ];

  const handleInvite = () => {
    const email = inviteEmail.trim();

    if (!email) {
      setInviteError(t("MAIL.INTRODUCE"));
      return;
    }
    if (!/^[a-zA-Z0-9._-]+$/.test(email)) {
      setInviteError(t("MAIL.INVALID"));
      return;
    }

    onInvite(`${email}${DOMAIN}`, inviteRole);
    onClose?.();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="bg-white rounded-xl shadow-lg w-full max-w-md">
        <div className="flex items-center justify-between px-6 pt-4 pb-3">
          <h2 className="text-base font-semibold text-darkGray">{t("USERS.ADD")}</h2>
          <button
            type="button"
            className="text-mediumGray hover:text-darkGray text-lg leading-none"
            onClick={onClose}
          >
            &times;
          </button>
        </div>

        <div className="border-t border-darkGray mx-6" />

        <div className="px-6 py-6">
          <div className="flex flex-col gap-4">
            <div className="w-full">
              <div
                className={`flex items-center gap-1 rounded-lg border px-4 py-3 ${
                  inviteError ? "border-red-500" : "border-gray-300"
                }`}
              >
                <input
                  autoFocus
                  value={inviteEmail}
                  onChange={(e) => {
                    const raw = e.target.value.trim();
                    const left = raw.split("@")[0];
                    setInviteEmail(left);
                    setInviteError("");
                  }}
                  placeholder={t("MAIL.EMAIL")}
                  className="flex-1 min-w-0 outline-none text-sm text-darkGray"
                />
                <span className="text-sm text-mediumGray select-none shrink-0">
                  {DOMAIN}
                </span>
              </div>

              {inviteError && <p className="mt-1 text-xs text-red">{inviteError}</p>}
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 items-end">
              <div>
                <SelectField
                  label={t("USERS.ROLE")}
                  placeholder={t("USERS.SELECT_ROLE")}
                  options={roleOptions}
                  value={inviteRole}
                  onChange={(e) => setInviteRole(e.target.value)}
                  className="w-full"
                />
              </div>

              <div>
                <MainButton
                  variant="primary"
                  className="w-full px-3 h-[40.8px] py-0 !text-base font-semibold"
                  onClick={handleInvite}
                >
                  {t("ACTIONS.INVITE")}
                </MainButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}